class LoadMore {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            let page = 2; // start from the second page
            let morePostsButton = document.getElementById("more_posts");

            if (morePostsButton) {
                // Remove all event listeners from the button
                morePostsButton.replaceWith(morePostsButton.cloneNode(true));
                morePostsButton = document.getElementById("more_posts");  // Get the reference to the new button

                morePostsButton.addEventListener("click", () => {
                    const category = morePostsButton.getAttribute("data-category");
                    this.loadMore(category, page)
                        .then((response) => {
                            // If response is 'END', hide the button and return
                            if (response.trim() === "END") {
                                morePostsButton.style.display = "none";
                                return;
                            }

                            // Append the response (new posts) after the last post
                            morePostsButton.insertAdjacentHTML("beforebegin", response);
                            // Increment the page number for the next AJAX request
                            page++;
                        })
                        .catch((error) => {
                            console.error("Error loading more posts:", error);
                        });
                });
            }
        });
    }

    loadMore(category, page) {
        console.log(`Loading more posts. Category: ${category}, Page: ${page}`);  // Log the category and page number

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", my_ajax_object.ajax_url, true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    resolve(xhr.responseText);
                } else if (xhr.readyState === 4) {
                    reject(xhr.statusText);
                }
            };

            xhr.send(`action=my_load_more_posts&category=${category}&page=${page}`);
        });
    }
}

const loadMore = new LoadMore();

export function initLoadMore() {
    loadMore.init();
}
